import { render, staticRenderFns } from "./Discounts.vue?vue&type=template&id=558559a0"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports